// extracted by mini-css-extract-plugin
export var active = "_gm-2";
export var recordingDot = "_gm-1";
export var recordingIndicator = "_gm-0";